// Centralized brand & site data for MLC Epoxy Floors.

export const SITE = {
  name: "MLC Epoxy Floors",
  tagline: "Premium Epoxy Floors. Built To Outlast.",
  phone: "(587) 329-3590",
  phoneHref: "tel:+15873293590",
  email: "info@mlcepoxyfloors.ca",
  address: {
    street: "260 South Point Pk SW",
    city: "Airdrie",
    region: "AB",
    postal: "T4B 0X2",
    country: "CA",
  },
  hours: "Open 24 Hours",
  geo: { lat: 51.2917, lng: -114.0144 },
  social: {
    instagram: "",
    facebook: "https://www.facebook.com/mlcepoxy.ca/",
    google: "https://www.google.com/search?kgmid=/g/11zcglphcr",
  },
};

export const SERVICES = [
  {
    slug: "flake-epoxy-flooring",
    name: "Flake Epoxy Flooring",
    short: "Decorative vinyl chip system with polyaspartic topcoat.",
    benefits: ["Anti-slip texture", "Hides imperfections", "Endless color blends"],
  },
  {
    slug: "metallic-epoxy-flooring",
    name: "Metallic Epoxy Flooring",
    short: "High-gloss liquid metal effect floors for a showroom finish.",
    benefits: ["3D pearlescent depth", "One-of-a-kind pattern", "Premium showroom look"],
  },
  {
    slug: "solid-color-epoxy-flooring",
    name: "Solid Color Epoxy Flooring",
    short: "Clean, uniform single-color epoxy for residential and commercial floors.",
    benefits: ["Seamless surface", "Easy to clean", "Industrial durability"],
  },
  {
    slug: "polyaspartic-floor-coatings",
    name: "Polyaspartic Floor Coatings",
    short: "UV-stable, fast-curing topcoat that outperforms standard epoxy.",
    benefits: ["1-day install", "100% UV stable", "Chemical & abrasion resistant"],
  },
  {
    slug: "grind-and-seal-concrete",
    name: "Grind & Seal Concrete",
    short: "Mechanically polished concrete sealed with a high-performance coating.",
    benefits: ["Natural concrete look", "Low maintenance", "Cost-effective"],
  },
  {
    slug: "concrete-resurfacing",
    name: "Concrete Resurfacing",
    short: "Repair spalling, cracking, and salt-damaged concrete — then seal it for good.",
    benefits: ["Fixes spalling & cracks", "Salt & freeze-thaw proof", "Garage, patio & shop floors"],
  },
] as const;

export const CITIES = [
  { slug: "calgary-ab", name: "Calgary", state: "AB", region: "Calgary Region",
    landmarks: ["Downtown", "Beltline", "Aspen Woods", "Mahogany", "Tuscany"] },
  { slug: "airdrie-ab", name: "Airdrie", state: "AB", region: "Calgary Region",
    landmarks: ["South Point", "Bayside", "Kingsview", "Cooper's Crossing"] },
  { slug: "chestermere-ab", name: "Chestermere", state: "AB", region: "Calgary Region",
    landmarks: ["Lakeside", "Westmere", "Rainbow Falls", "Chelsea"] },
  { slug: "cochrane-ab", name: "Cochrane", state: "AB", region: "Calgary Region",
    landmarks: ["Sunset Ridge", "Heartland", "Heritage Hills", "Riverview"] },
  { slug: "okotoks-ab", name: "Okotoks", state: "AB", region: "Calgary Region",
    landmarks: ["Drake Landing", "Cimarron", "Sheep River", "Air Ranch"] },
] as const;

export const TRUST_POINTS = [
  "Fully Insured",
  "Residential & Commercial",
  "Premium Materials",
  "Free Estimates",
  "Locally Owned",
  "Serving Calgary & Area",
];

export const FEATURES = [
  { icon: "clock", title: "Installed in 1–2 Days", body: "Most garage floors are ready to walk on in 24 hours and drive on in 48." },
  { icon: "zap", title: "5× Stronger Than DIY Epoxy", body: "Industrial-grade polyaspartic top coat — built to handle heavy vehicles and daily use." },
  { icon: "sun", title: "Won't Yellow or Fade", body: "UV-stable coating keeps your floor looking new for years — even in direct sunlight." },
  { icon: "truck", title: "Resists Hot-Tire Pickup", body: "Engineered for real garage use — tire marks, chemicals and impacts won't damage it." },
  { icon: "sparkles", title: "Easy to Clean", body: "Oil, dirt and spills wipe right off the seamless, non-porous surface." },
  { icon: "shield", title: "Slip-Resistant", body: "Textured flake finish provides safe footing even when wet." },
  { icon: "droplets", title: "Chemical & Stain Proof", body: "Salt, oil, gas, paint and household chemicals can't penetrate the coating." },
  { icon: "palette", title: "Fully Customizable", body: "Choose from flake blends, solid colors or stunning metallic finishes." },
];


export const PROCESS = [
  { n: 1, title: "Diamond Grinding", body: "We mechanically profile the concrete with industrial planetary grinders for a permanent bond." },
  { n: 2, title: "Concrete Repairs", body: "Cracks, spalls, and pitting are filled with structural polyurea before coatings go down." },
  { n: 3, title: "Primer Application", body: "A penetrating epoxy or polyaspartic primer locks into the open profile." },
  { n: 4, title: "Basecoat Installation", body: "High-build pigmented basecoat is rolled to a uniform mil thickness." },
  { n: 5, title: "Decorative Flake Broadcast", body: "Flake or metallic pigment is broadcast wet-into-wet for full saturation." },
  { n: 6, title: "Polyaspartic Topcoat", body: "Two coats of UV-stable polyaspartic seal everything in — gloss or satin." },
  { n: 7, title: "Final Inspection", body: "We walk every square foot with you and back the job with a written warranty." },
];

export const TESTIMONIALS = [
  { name: "Michael R.", city: "Calgary, AB", stars: 5,
    quote: "MLC transformed our 3-car garage into something nicer than the inside of our house. Crew was punctual, professional, and meticulous." },
  { name: "Sarah K.", city: "Airdrie, AB", stars: 5,
    quote: "The metallic finish is breathtaking. Everyone who comes over asks about it. Worth every penny." },
  { name: "David L.", city: "Cochrane, AB", stars: 5,
    quote: "Got three estimates and MLC was the most knowledgeable by far. They actually grind the concrete — others wanted to acid etch. Floor still looks new two years in." },
  { name: "Jennifer P.", city: "Calgary, AB", stars: 5,
    quote: "We coated the floor of our commercial space and the install was done in a weekend with zero disruption. Spotless work." },
  { name: "Tom B.", city: "Chestermere, AB", stars: 5,
    quote: "Honest pricing, no upsells, and they finished a day early. The polyaspartic topcoat is bulletproof — even handles my motorcycle stands." },
  { name: "Lauren H.", city: "Okotoks, AB", stars: 5,
    quote: "From quote to install, completely professional. They prepped, primed, and topcoated in a single day. I parked in it the next morning." },
];
